export enum IStateType {
  FREE = 0,
  IN_QUE = 1,
  MISS_ENTER_GAME = 2,
  CAN_ENTER_GAME = 3,
  CAN_RETURN_GAME = 4,
}
